import React from "react"

import BeInspired from "./be-inspired"
import Music from "./music"
import RedSoda from "./red-soda"
import Locations from "./locations"
import BandTypes from "./band-types"

import "./style.less"

const Nav = ({ routeParams }) => (
  <nav className="footer-nav">
    <div className="max-w-screen-reds-2xl w-full m-auto px-8 lg:pt-28 pt-8 grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-y-20">
      <div className="be-inspired-column w-full">
        <BeInspired routeParams={routeParams} />
      </div>
      <div className="music-column w-full">
        <Music routeParams={routeParams} />
      </div>
      <div className="red-soda-column w-full">
        <RedSoda routeParams={routeParams} />
      </div>
      <div className="locations-column w-full">
        <Locations routeParams={routeParams} />
      </div>
      <div className="brand-types-column w-full col-span-2">
        <BandTypes routeParams={routeParams} />
      </div>
    </div>
  </nav>
)

export default Nav
